import { render, staticRenderFns } from "./Select.vue?vue&type=template&id=3921c087&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"
import style0 from "./Select.vue?vue&type=style&index=0&id=3921c087&prod&scoped=true&lang=scss"
import style1 from "./Select.vue?vue&type=style&index=1&id=3921c087&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921c087",
  null
  
)

export default component.exports